import { AggRelayEnvironment, createRelayResource } from '@townsquare/relay-utils';
import { ResourceContext } from '@townsquare/router';
import { getIsExperimentEnabledWithoutExposure } from '@townsquare/stat-sig';
import { DISCOVER_FEED_EXPERIMENT } from '@townsquare/stat-sig/experiments';
import { isGateEnabled } from '@townsquare/stat-sig/gate';

import { timeframeMap } from '../constants';
import useLabelFeedPostsQuery, {
  type useLabelFeedPostsQuery as useLabelFeedPostsQueryType,
} from '../hooks/__generated__/useLabelFeedPostsQuery.graphql';
import { getTimeframe } from '../types';

export const farewellFeedResource = createRelayResource<useLabelFeedPostsQueryType>({
  getQuery: (routerContext, resourceStoreContext) => {
    const context = resourceStoreContext as ResourceContext;

    const timeframe = getTimeframe(routerContext.query.timeGranularity);

    const isEnabled =
      !!context.collabContext?.rovoWorkspace &&
      getIsExperimentEnabledWithoutExposure(DISCOVER_FEED_EXPERIMENT) &&
      isGateEnabled('townsquare_enable_popular_tabs');

    const cqlQuery = `label = "farewell-blog" AND created > now("${timeframeMap[timeframe]}") order by created desc`;

    return {
      query: useLabelFeedPostsQuery,
      variables: {
        cloudId: context.collabContext?.rovoWorkspace,
        cqlQuery,
        isEnabled,
      },
      environment: AggRelayEnvironment,
    };
  },
  maxAge: 60_000 * 30, // 30 minute cache during the SPA session to avoid flickering
});
